import createRestClient from '@/shared/api/restClient';
import { type DownloadEnvelopeFilesRequest } from '~/common/types/finance/accounting';

const restClient = createRestClient(null, true);

const downloadEnvelopes = (envelopeTrackingIds: string[], setToDownloaded?: boolean) =>
  restClient.put<Blob>(
    '/finance/accounting/envelope/download',
    {
      envelopeTrackingIds,
      setToDownloaded: setToDownloaded ?? false,
    } satisfies DownloadEnvelopeFilesRequest,
    { responseType: 'blob' },
  );

export default {
  downloadEnvelopes,
};
